import { call, put } from 'redux-saga/effects';
import GetLeavesMakeUpSessionActions from '../redux/GetLeavesMakeUpSessionRedux';
import { api } from './api';

export function* getLeavesMakeUpSession(action: any): Generator<any, void, any> {
  const { children_id, page, isTherapist } = action;
  
  // Call appropriate API based on user type
  const response = isTherapist 
    ? yield call(api.getLeavesMakeUpSessionTherapist, children_id)
    : yield call(api.getLeavesMakeUpSession, children_id, page.toString());

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetLeavesMakeUpSessionActions.getLeavesMakeUpSessionSuccess(response.data));
  } else {
    yield put(GetLeavesMakeUpSessionActions.getLeavesMakeUpSessionFailure());
  }
}